import React, { useState } from "react";
import { Link } from "react-router-dom";
import LazyLoad from "react-lazyload";

const rawHeadGirls = [
  "Sampurna Shania  Chakraborty|2025-26",
  "Kaashvi Malhotra|2024-25",
  "Angela Elizabeth Domingo|2023-2024",
  "Meryl Teresa Anthony|2022-23",
  "Sonia Xalxo|2021-2022",
  "Novelle Jibby John|2020-2021",
  "Ria Jain|2019-20",
  "Rebecca Jose|2018-2019",
  "LYDIA NENGHOITHEM HAOKIP|2017-2018",
  "Zoya Jaffery|2016-2017",
  "Fiza Jaggi|2015-2016",
  "Shaoni Kar|2014-2015",
  "Adwaidha L Santosh|2013-2014",
  "Ashwathy Babu Paul|2012-2013",
  "Aishwarya Sastry|2011-2012",
  "Damandeep Dang|2010-2011",
  "Megha Jacob|2009-2010",
  "Vasundhara Jalali|2008-2009",
  "Shireen Lal|2007-2008",
  "Stuti Punn Lible Babu|2006-2007",
  "Vineeta Verghese|2005-2006",
  "Betsy Thomas|2004-2005",
  "Suchi Nautriyal|2003-2004",
  "Christina Almeida|2002-2003",
  "Vasudha Sarda|2001-2002",
  "Christina Fernandes|2000-2001",
  "Jasmine Kaur, Arshilya Singh|1999-2000",
  "Ashima Gogia, Komila Punia|1998-1999",
  "Teena Sethi, Jasmine Kaur|1997-1998",
  "Tanvi Madan, Neha Anand|1996-1997",
  "Leona Christy, Kajal Rana|1995-1996",
  "Mora Ann Oomen|1994-1995",
  "Anshul Grover|1993-1994",
  "Shagun Sahgal|1992-1993",
  "----|1991-1992",
  "Archana Gupta|1990-1991",
  "Anjali Puri|1989-1990",
  "Harmeet Chadha|1988-1989",
  "Ritika Khanna|1987-1988",
  "Sonali Passi|1986-1987",
  "Meeney Dhir|1985-1986",
  "----|1984-1985",
  "Radhika Kaul|1983-1984",
  "Bihu Goyle|1982-1983",
  "Bandana Singh|1981-1982",
  "Anita Gupta|1980-1981",
  "Vandana Grover|1979-1980",
  "Jasmeeta Singh|1978-1979",
  "Uma Nair|1977-1978",
  "---|1976-1977",
  "Vimla Masilanani|1975-1976",
  "Rita Goel|1974-1975",
  "Poornima Bakhshi|1973-1974",
  "----|1972-1973",
  "----|1971-1972",
  "Rashmi Kalaan|1970-1971",
  "Vinita Wali|1969-1970",
  "----|1968-1969",
  "Anna Verghese|1967-1968",
  "Anu Kaapur|1966-1967",
];

const chunkArray = (arr, chunkSize = 3) => {
  const chunks = [];
  for (let i = 0; i < arr.length; i += chunkSize) {
    chunks.push(arr.slice(i, i + chunkSize));
  }
  return chunks;
};

const HeadGirls = () => {
  const [headGirls] = useState(rawHeadGirls);
  const chunked = chunkArray(headGirls);

  return (
    <>
      <section className="page-header">
        <div className="page-header-bg"></div>
        <div className="page-header-shape-1">
          <LazyLoad>
            <img
              src="https://webapi.entab.info/api/image/LCSD/public/Images/page-header-shape-1.png"
              alt="Loreto Convent School, Delhi Cantt"
            />
          </LazyLoad>
        </div>
        <div className="container">
          <div className="page-header__inner">
            <ul className="thm-breadcrumb list-unstyled ml-0">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>Office Bearers</li>
              <li>Head Girls</li>
            </ul>
            <h2>Head Girls</h2>
          </div>
        </div>
      </section>

      <section className="innerbody">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <table className="table table-striped table-bordered">
                <tbody>
                  {chunked.map((row, i) => (
                    <tr key={i}>
                      {row.map((entry, j) => {
                        const [name, year] = entry.split("|");
                        return (
                          <td key={j}>
                            {name}
                            <br />
                            {year}
                          </td>
                        );
                      })}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HeadGirls;
